import { Link } from 'react-router-dom';
import { getPopularComics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function PopularComics() {
  const popularComics = getPopularComics(8);

  return (
    <section className="py-14 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">热门漫画推荐</h2>
            <p className="mt-2 text-foreground-500 text-sm">最受读者欢迎的韩漫作品，精彩不容错过</p>
          </div>
          <Link
            to="/category/shuang-nanzhu"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4" data-product-shop>
          {popularComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/shuang-nanzhu"
            className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}